import consts from '@shared/consts';
import { atom, useAtomValue } from 'jotai';


const root = window.document.documentElement;
const availableCustomThemes = window.txConsts.customThemes.map((theme) => theme.name);
const customThemesClasses = window.txConsts.customThemes.map((theme) => `theme-${theme.name}`);

const initialCustomTheme = availableCustomThemes.find((name) => root.classList.contains(`theme-${name}`))
    ?? (availableCustomThemes.includes(window.txConsts.defaultTheme) ? window.txConsts.defaultTheme : undefined);
const currentTheme = initialCustomTheme ?? 'dark';


root.classList.remove('light', ...customThemesClasses);
root.classList.add('dark');
if (initialCustomTheme) {
    root.classList.add(`theme-${initialCustomTheme}`);
}
document.cookie = `${consts.cookies.theme}=${currentTheme};path=/;SameSite=Lax;max-age=31536000;`;


const themeAtom = atom(currentTheme);


/**
 * Hooks
 */
export const useTheme = () => ({
    theme: useAtomValue(themeAtom),
    setTheme: (_newTheme: string) => { },
});

export const useToggleTheme = () => () => { };

export const useIsDarkMode = () => true;

export const useThemedImage = (baseImageUrl?: string) => {
    if (typeof baseImageUrl !== 'string') return;
    return baseImageUrl.replace(/{theme}/g, 'dark');
};
